/**
 * Checks if a listing is a hotel based on its ID prefix
 * Hotels are identified by IDs that start with "e-"
 * 
 * @param listingId - The ID of the listing to check
 * @returns boolean indicating if the listing is a hotel
 * 
 * @example
 * isHotel("e-123") // returns true
 * isHotel("abc123") // returns false
 * isHotel(null) // returns false
 * isHotel(undefined) // returns false
 */
export const isHotel = (listingId: string | null | undefined): boolean => {
    if (!listingId) return false;
    return listingId.startsWith('e-');
};
